<div class="p-d-flex p-flex-row p-justify-center p-align-center" *ngIf="innerHtml" [innerHTML]="innerHtml" style="height: 71vh"></div>
